import { get } from '@utils/axios_api';
import { useQuery } from '@tanstack/react-query';

const fetchTerms = () => get('/terms/termsList').then(res => res.result); 

export function useTerms() {
  return useQuery(['selectTerms'], fetchTerms);
}